import React from 'react';
import { call } from '../utilities/http';
import { COMPLETE, PROJECTS_CREATE_OK, PROJECTS_GET_OK, SAVING, LOADING } from './types';
import { Snackbar } from '../components/snackbar';
import { FormattedMessage } from 'react-intl';
import { sortByString } from '../utilities/string';

const defaultState = {
    list: undefined
};

/**
 * Projects state mapper.
 * @param {object} state
 * @param {string} action
 */
export default function(state = defaultState, action) {
    switch (action.type) {
        case PROJECTS_CREATE_OK:
            return { ...state };

        case PROJECTS_GET_OK:
            return { ...state, list: action.data };

        default:
            return state;
    }
}

/**
 * Create project record.
 *
 * @param {Object} data
 * @param {Function} onSuccess
 */
export function saveProject(data, onSuccess = response => null) {
    const callDefinition = {
        path: `/project/${data.id || ''}`,
        method: data.id ? 'PUT' : 'POST',
        body: data
    };

    return async function(dispatch) {
        dispatch({ type: SAVING });
        call(callDefinition)
            .then(response => {
                dispatch({ type: PROJECTS_CREATE_OK, data: response });
                dispatch({ type: COMPLETE });
                onSuccess(response);
            })
            .catch(error => {
                Snackbar.error(<FormattedMessage id={'error.saveProjectRecord'} defaultMessage={'Unable to save project entry.'} />);
                dispatch({ type: COMPLETE });
            });
    };
}

/**
 * Remove project record.
 *
 * @param {String} projectId
 * @param {Function} onSuccess
 */
export function removeProject(projectId, onSuccess = response => null) {
    const callDefinition = {
        path: `/project/${projectId}`,
        method: 'DELETE'
    };

    return async function(dispatch) {
        dispatch({ type: SAVING });
        call(callDefinition)
            .then(response => {
                dispatch({ type: COMPLETE });
                onSuccess(response);
            })
            .catch(error => {
                Snackbar.error(<FormattedMessage id={'error.removeProjectRecord'} defaultMessage={'Unable to remove project entry.'} />);
                dispatch({ type: COMPLETE });
            });
    };
}

/**
 * Get client's project records for.
 *
 * @param {String} clientId
 * @param {String} status
 * @param {Function} onSuccess
 */
export function getClientsProjects(clientId, status, onSuccess = response => null) {
    return async function(dispatch) {
        dispatch({ type: LOADING });
        const queryParams = status ? `?status=${status}` : '';
        call({ path: `/client/${clientId}/projects${queryParams}`, method: 'GET' })
            .then(response => {
                const sortedProjects = response && sortByString(response, 'name');
                dispatch({ type: PROJECTS_GET_OK, data: sortedProjects });
                dispatch({ type: COMPLETE });
                onSuccess(response);
            })
            .catch(error => {
                Snackbar.error(<FormattedMessage id={'error.getProjects'} defaultMessage={'Unable to get projects for client.'} />);
                dispatch({ type: COMPLETE });
            });
    };
}



// WEBPACK FOOTER //
// ./src/reducers/projects.jsx